import { GeneralFieldController } from "./general-field-controller";
import { isEmptyValue } from "../utils/is-empty-value";

export class GeneralBooleanCustomAttributeFieldController extends GeneralFieldController {
	override mapInitialValue(value: unknown): unknown {
		return isEmptyValue(value) ? false : value;
	}
}
